import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const useDashboardListRowStyles = makeStyles(theme => ({
  rightArrow: {
    textAlign: 'center',
    alignSelf: 'center',
    color: brandColors.coolGray5,

    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  },
  rowHeader: {
    paddingBottom: theme.spacing(1),
  },
  row: {
    '&:hover, &:focus': {
      backgroundColor: brandColors.coolGray1,
    },
    padding: theme.spacing(2),
    borderBottom: `1px solid ${brandColors.coolGray1}`,
  },
  buttonBase: {
    display: 'inline',
  },
}))
